import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Thanks.module.css';

const Thanks = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Meta Pixel Code
    // eslint-disable-next-line no-unused-expressions
    (function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)})(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    
    if (window.fbq) {
      window.fbq('init', '811603208566919');
      window.fbq('track', 'PageView');
    }
  }, []);

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      {/* Meta Pixel Noscript Fallback */}
      <noscript>
        <img 
          height="1" 
          width="1" 
          style={{display: 'none'}}
          src="https://www.facebook.com/tr?id=811603208566919&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>

      <div className={styles.card}>
        {/* Success Icon */}
        <div className={styles.iconWrapper}>
          <svg className={styles.successIcon} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M8 12.5L10.5 15L16 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Main Heading */}
  

        {/* Success Message */}
        <div className={styles.messageBox}>
          <p className={styles.message}>הפרטים התקבלו בהצלחה.</p>
          <p className={styles.description}>
            אחד מאנשי הצוות יעבור על התשובות ויצור קשר אם נמצא התאמה למסלול.
          </p>
        </div>

        {/* Back Button */}
        <button onClick={handleBackToHome} className={styles.backButton}>
          <svg className={styles.arrowIcon} viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          חזרה לעמוד הראשי
        </button>
      </div>
    </div>
  );
};

export default Thanks;